var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.69 1.63L18.54.415l4.37 17.461-4.85 1.214-4.37-17.462zM5 1H0v18h5V1zm7 0H7v18h5V1zm10 20H0v2h22v-2z"
  })));
}

export default __webpack_public_path__ + "3e4b9d2ce9b4937d63c1a8aa8e2a3340.svg";
export { SvgLibrary as ReactComponent };